import { ChangeDetectorRef, EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';

import { RelatedToType } from '@shared/enums';
import { FieldDef, SavedView } from '@core/models';

@Component({
  selector: 'field-defs-panel',
  templateUrl: './field-defs-panel.component.html',
  styleUrls: ['./field-defs-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldDefsPanelComponent implements OnInit {
  @Input() fieldDefs: FieldDef[];
  @Input() savedView: SavedView;
  @Input() sortColumnToFirst: boolean = true;
  @Input('displayColumns') set _displayColumns(value: string[]) {
    this.displayColumns = [...value];
  }

  @Output() columnsChanged = new EventEmitter<string[]>();

  displayDefs: any;
  displayColumns: string[] = [];

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.displayColumns) {
      for (let column of this.displayColumns.slice().reverse()) {
        this.displayDefs = this.moveToFirst(column, this.fieldDefs);
      }
    }
  }

  private moveToFirst(columnName: string, columnsList: FieldDef[] = []): FieldDef[] {
    const index = columnsList.findIndex((column) => column?.name === columnName);
    if (index !== -1) {
      const coverImage = columnsList.splice(index, 1);
      columnsList.unshift(coverImage.shift());
      return columnsList;
    }
  }

  private removeDisplayColumn(fieldName: string): void {
    this.displayColumns.splice(
      this.displayColumns.findIndex((item) => item === fieldName),
      1,
    );
    this.cleanseDisplayColumns();
    this._changeDetectorRef.markForCheck();
  }

  private addDisplayColumn(fieldName: string): void {
    let index = this.displayColumns.findIndex((item) => item === fieldName);
    if (index == -1) {
      this.displayColumns.unshift(fieldName);
      this.cleanseDisplayColumns();
    }

    this._changeDetectorRef.markForCheck();
  }

  private cleanseDisplayColumns(): void {
    if (this.displayDefs[0].related_to_type === RelatedToType.Project) this.cleanseProject(this.sortColumnToFirst);
    else this.cleanseProperty(this.sortColumnToFirst);
    this.columnsChanged.emit(this.displayColumns);
  }

  private cleanseProject(shouldSortColumnToFirst: boolean): void {
    if (shouldSortColumnToFirst) {
      const index = this.displayColumns.findIndex((item) => item === 'title');

      if (index > -1) {
        this.displayColumns.splice(index, 1);
      }
      this.displayColumns.unshift('title');
    }
  }

  private cleanseProperty(shouldSortColumnToFirst: boolean): void {
    if (shouldSortColumnToFirst) {
      const index = this.displayColumns.findIndex((item) => item === 'name');

      if (index > -1) {
        this.displayColumns.splice(index, 1);
      }
      this.displayColumns.unshift('name');
    }
  }

  toggleDisplayColumn(fieldName: any, change: MatCheckboxChange): void {
    if (change.checked) {
      this.addDisplayColumn(fieldName);
    } else {
      this.removeDisplayColumn(fieldName);
    }
  }

  filterFields(event): void {
    const value = event.target.value.toLowerCase();
    this.displayDefs = this.fieldDefs.filter((fieldDef) => fieldDef.label.toLowerCase().includes(value));
  }

  filterFieldsInputKeyDown(event): void {
    if (event.key !== 'Enter') {
      return;
    }

    const fieldDef = this.displayDefs[0];
    const isFieldVisible = this.fieldDefs.find((item) => item.name === fieldDef.name);

    if (isFieldVisible) {
      this.removeDisplayColumn(fieldDef.name);
    } else {
      this.addDisplayColumn(fieldDef.name);
    }
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
